module.exports = __webpack_public_path__ + "img/应急模拟.cc9618ed.png";